module.exports = __webpack_public_path__ + "static/media/logo-blanco.6b1cc5f4.png";